import { Epic } from 'redux-observable';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';
import { ofType, queryParamsBuilder } from '@alycecom/utils';
import { AnyAction } from 'redux';

import { getUrlWithoutDomain } from '../../../helpers/url.helpers';

import {
  checkCodeRequest,
  checkCodeSuccess,
  checkCodeFail,
  processLinkRequest,
  processLinkSuccess,
  processLinkFail,
  setCodeError,
  setRedirectUrl,
  codeParamsRequest,
  codeParamsSuccess,
  codeParamsFail,
} from './code.actions';
import { ICheckCodeResponse, TAjaxCodeResponse } from './code.types';

export const checkCodeEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(checkCodeRequest),
    mergeMap(({ payload: code }) =>
      apiService.post(`/have-code-ajax`, { body: { code } }).pipe(
        mergeMap((response: TAjaxCodeResponse) => {
          const {
            success,
            errors,
            redirect_url: routeUrl,
            error_message_data: params,
            error_message: errorMessage,
          } = response;

          const action: AnyAction[] = [];
          if (success) {
            const url = getUrlWithoutDomain(routeUrl);
            action.push(processLinkRequest(url));
          } else if (routeUrl) {
            action.push(setRedirectUrl(routeUrl));
          } else {
            action.push(checkCodeSuccess(), setCodeError({ code: errors.code as string, params }));
          }

          if (errorMessage) {
            action.push(codeParamsSuccess(errorMessage));
          }

          return action;
        }),
        catchError(errorHandler({ callbacks: checkCodeFail })),
        takeUntil(action$.ofType(checkCodeRequest)),
      ),
    ),
  );

export const processLinkEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(processLinkRequest),
    mergeMap(({ payload: url }) =>
      apiService.get(url).pipe(
        map(({ success, errors, redirect_url: redirectUrl }: TAjaxCodeResponse) =>
          success ? processLinkSuccess(redirectUrl) : setCodeError({ code: errors.code as string }),
        ),
        catchError(errorHandler({ callbacks: processLinkFail })),
      ),
    ),
  );

export const errorCodeParamsEpic: Epic = (action$, state$, { apiService, messagesService: { errorHandler } }) =>
  action$.pipe(
    ofType(codeParamsRequest),
    mergeMap(({ payload: { hashId, draftId, code, campaignId } }) =>
      apiService
        .get(`/recipient/error-message-data?${queryParamsBuilder({ hashId, draftId, code, campaignId })}`, null, true)
        .pipe(
          map((response: ICheckCodeResponse) => codeParamsSuccess(response.data)),
          catchError(errorHandler({ callbacks: codeParamsFail })),
        ),
    ),
  );

export const codeEpics = [checkCodeEpic, processLinkEpic, errorCodeParamsEpic];
